<template>
  <div class="searchResults" id="right_column">

    <div v-if="viewFormat === 'grid'" class="gridView">

      <div class="row vehicle_results mx-1 mb-3 pb-2 border border-primary" v-for="car in carsFiltered" :key="car.vin + car.order_num" :data-vin="car.vin">

        <div class="promo_ribbon_ul_wrapper_outer">

          <div class="promo_ribbon_ul_wrapper_inner">

            <div :class="statusBGColor(car)" class="promo_ribbon_ul">{{ status(car) }}</div>

          </div>

        </div>

        <div class="col-12 col-md-4 mb-2">

          <a
            :href="getViewDetailsLink(car)"
          >

            <img
              :alt="car.year + ' ' + car.make + ' ' + car.model + ' | Stk#: ' + car.stock_num"
              v-lazy="car.actual_photos_single ? car.actual_photos_single : car.best_stock_photo"
              class="img-fluid"
            />

          </a>

        </div>

        <div class="col-12 col-sm-6 col-md-4">

          <h5 class="text-center text-sm-left"><a class="text-brand-secondary" :href="getViewDetailsLink(car)">{{ car.year }} {{ car.make }} {{ car.model }} {{ car.trim }}</a></h5>

          <hr class="mt-2 mb-1 d-none d-md-block" style="border-top: 2px solid #DBDBDB;">

          <div class="row no-gutters mb-2 d-none d-lg-flex">

            <div class="col-12 py-2">

              <strong>STOCK:</strong> <span v-if="car.stock_num">{{ car.stock_num }}</span><span v-else>N/A</span><br>

              <strong>VIN:</strong> <span v-if="car.vin">{{ car.vin }}</span><span v-else>N/A</span>

            </div>

          </div>

          <ul class="list-unstyled mb-0">

            <li class="smallish d-lg-none"><strong>STOCK:</strong> <span v-if="car.stock_num !== 'null'">{{ car.stock_num }}</span><span v-else>N/A</span></li>

            <li class="smallish d-lg-none"> <strong>VIN:</strong> {{ car.vin }}</li>

            <li v-if="car.stock_type === 'used'" class="smallish"><strong>MILEAGE: </strong>{{ addComma(car.mileage) }}</li>

            <li class="smallish" v-if="car.trim"><strong>TRIM: </strong>{{ car.trim }}</li>

            <li class="smallish" v-if="car.drive"><strong>DRIVE: </strong>{{ car.drive }}</li>

            <li class="smallish" v-if="car.transmission"><strong>TRANSMISSION: </strong>{{ car.transmission }}</li>

            <li class="smallish" v-if="car.color"><strong>COLOR: </strong>{{ car.color }}</li>

            <li class="smallish" v-if="car.color || car.engine_type"><strong>ENGINE: </strong>{{ car.displ_liters }} Liter | {{ car.engine_type }}</li>

            <li class="smallish" v-if="car.style"><strong>STYLE: </strong>{{ car.style }}</li>

            <li class="smallish" v-if="car.fuel_economy_city_high"><strong><span class="link" data-toggle="tooltip" boundary="viewport" :title="'Based on ' + car.year + ' EPA mileage ratings. Use for comparison purposes only. Your actual mileage will vary, depending on how you drive and maintain your vehicle, driving conditions, battery pack age/condition (hybrid only), and other factors.'">MPG</span>: </strong>{{ car.fuel_economy_city_high }} CITY / {{ car.fuel_economy_hwy_high }} HWY</li>

          </ul>

        </div>

        <div class="col-12 col-sm-6 col-md-4">

          <h5 class="text-center text-md-right"><span v-if="car.final_price > 0">${{ addComma(car.final_price) }}</span><span v-else>N/A</span></h5>
          <p class="d-sm-none text-center">
            <span
              data-toggle="modal"
              data-target="#vehicle_price_details_modal"
              :data-vin="car.vin"
              class="pointer mb-1"
              title="Price Details"
            >(See Price Details)</span>
          </p>

          <div class="d-none d-sm-block">

          <hr class="mt-2 mb-1 d-none d-md-block" style="border-top: 2px solid #DBDBDB;">

          <span class="d-sm-none">
            <a
              class="mb-2 d-block text-center color-brand-pop link"
              href="#"
              data-toggle="collapse"
              role="button"
              :aria-expanded="true"
              :aria-controls="'collapsePriceDetails-' + car.vin"
              v-b-toggle="'collapsePriceDetails-' + car.vin"
              variant="primary"
              >Price Details
            </a>
          </span>

          <div id="view-detailed-pricing">

            <table class="table table-sm small mb-0" v-if="car.stock_type === 'new'">

              <tbody>

                <tr v-if="showHiddenPricing !== false">
                  <td style="border-top: none;border-bottom: 1px solid #8e8e8e;">Balance</td>
                  <td class="pricing-table-border text-right" style="border-top: none;"><span v-if="car.balance > 0">${{ addComma(car.balance) }}</span><span v-else>N/A</span></td>
                </tr>

                <tr>
                  <td style="border-top: none;">MSRP</td>
                  <td style="border-top: none;" class="text-right"><span v-if="car.sticker_price > 0">${{ addComma(car.sticker_price) }}</span><span v-else>N/A</span></td>
                </tr>

                <tr v-if="car.total_options_retail > 0">
                  <td style="border-top: 1px solid rgb(142, 142, 142);border-bottom: 1px solid #f8f9fa;" v-b-toggle="'collapse-' + car.vin">Dealer Accessories <svg class="icon icon-info" style="top: -1px;"><use xlink:href="/assets/svg/symbol-defs.svg#icon-info"></use></svg>  </td>
                  <td class="text-right" style="border-top: 1px solid rgb(142, 142, 142);border-bottom: 1px solid #f8f9fa;">${{ addComma(car.total_options_retail) }}</td>
                </tr>

              </tbody>

            </table>
            <b-collapse :id="'collapse-' + car.vin" v-if="car.total_options_retail > 0">
              <table class="table table-sm small mb-0 text-muted pricing-table-border" v-if="car.stock_type === 'new'">
                <tbody v-for="(opt_desc, opt_index) in car.option_descriptions" :key="opt_index" class="border-0">
                  <tr v-if="isAlaskaPackage(car.option_codes[opt_index]) === false">
                    <!-- Not Alaska Package -->
                    <td style="border-top: none;border-bottom: 1px solid #f8f9fa;">&bull; {{ opt_desc }}</td>
                    <td style="border-top: none;border-bottom: 1px solid #f8f9fa;" class="text-right">${{ car.option_retail_prices[opt_index]}}</td>
                  </tr>
                </tbody>
              </table>
            </b-collapse>
            <table class="table table-sm small mb-1" v-if="car.stock_type === 'new'">

              <tbody>

                <tr>
                  <td class="" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">Doc Fees</td>
                  <td class="text-right" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">$249</td>
                </tr>

                <tr>
                  <td class="" style="border-top: 1px solid #FFF;"><strong>List Price</strong></td>
                  <td class="text-right" style="border-top: 1px solid #FFF;">
                    <strong>
                      <span v-if="car.list > 249">${{ addComma(car.list) }}</span>
                      <span v-else-if="car.list < 200 && car.final_price > 249">${{ addComma(car.final_price) }}</span>
                      <span v-else>N/A</span>
                    </strong>
                  </td>
                </tr>

                <tr v-if="car.dealer_discount > 0">
                  <td style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;" class="color-brand-pop" :title="'Offer ends ' + prettyEndDate(car.end_date)"><strong>Continental Discount</strong></td>
                  <td style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;" class="text-right color-brand-pop bold"><strong>-${{ addComma(car.dealer_discount) }}</strong></td>
                </tr>

                <tr v-if="car.total_cash_incentives > 0 && car.dealer_discount > 0">
                  <td style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;"><strong>Dealer Price Before Incentives</strong></td>
                  <td style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;" class="text-right"><strong>${{ addComma(car.dealer_discount_price) }}</strong></td>
                </tr>

                <template v-if="car.total_cash_incentives > 0 || car.dealer_discount > 0">

                  <tr v-for="incentive in car.incentives" :key="incentive.incentive_id">

                    <template v-if="$root._.includes( incentive.incentive_group, 'Best Cash')">

                      <td class="color-brand-pop" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">
                        <a
                          href="#"
                          class="color-brand-pop"
                          :data-incentive-id="incentive.incentive_id"
                          data-toggle="modal"
                          data-target="#incentivesModal">{{ incentive.incentive_description }}
                        </a>
                      </td>
                      <td class="text-right color-brand-pop" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">-${{ addComma(incentive.incentive_value) }}</td>
                    </template>

                  </tr>

                </template>

                <tr v-if="car.total_cash_incentives > 0 || car.dealer_discount > 0">
                  <td style="border-top: 1px solid #8e8e8e;"><strong>Vehicle Price</strong></td>
                  <td class="text-right" style="border-top: 1px solid #8e8e8e;"><strong>${{ addComma(car.final_price) }}</strong></td>
                </tr>

              </tbody>

            </table>

            <table class="table table-sm small mb-1" v-if="car.stock_type === 'used'">

              <tbody v-if="showHiddenPricing !== false">

                <tr>
                  <td style="border-top: none;border-bottom: 1px solid #8e8e8e;">Balance</td>
                  <td style="border-top: none;border-bottom: 1px solid #8e8e8e;" class="text-right">${{ addComma(car.balance) }}</td>
                </tr>

              </tbody>

              <tbody v-if="car.book_value !== 0">

                <tr>
                  <td style="border-top: none;border-bottom: 1px solid #8e8e8e;">NADA Retail</td>
                  <td style="border-top: none;border-bottom: 1px solid #8e8e8e;" class="text-right">${{ addComma(car.book_value) }}</td>
                </tr>

                <tr>
                  <td class="color-brand-pop" style="border-top: 1px solid #FFF;border-bottom: 1px solid #8e8e8e;"><strong>Sale Price</strong></td>
                  <td class="text-right color-brand-pop" style="border-top: 1px solid #FFF;border-bottom: 1px solid #8e8e8e;"><strong>${{ addComma(car.base_price) }}</strong></td>
                </tr>

              </tbody>

              <tbody>

                <tr v-if="car.book_value === 0">
                  <td style="border-top: 1px solid #FFF;border-bottom: 1px solid #8e8e8e;"><strong>List Price</strong></td>
                  <td class="text-right" style="border-top: 1px solid #FFF;border-bottom: 1px solid #8e8e8e;"><strong>${{ addComma(car.base_price) }}</strong></td>
                </tr>

                <tr>
                  <td class="" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">Doc Fees</td>
                  <td class="text-right" style="border-top: 1px solid #8e8e8e;border-bottom: 1px solid #8e8e8e;">$249</td>
                </tr>

                <tr>
                  <td class="" style="border-top: 1px solid #FFF;"><strong>Final Price</strong></td>
                  <td class="text-right" style="border-top: 1px solid #FFF;"><strong>${{ addComma(car.final_price) }}</strong></td>
                </tr>

              </tbody>

            </table>

          </div>

          <ul class="list-unstyled mt-3">

            <li
              class="mb-1 bg-special"
              v-if="car.on_special === 'y'">
              <span class="text-white px-2 py-1 mb-2 small special d-block">
                <svg class="icon icon-star3"><use xlink:href="/assets/svg/symbol-defs.svg#icon-star3"></use></svg> On Special
              </span>
            </li>

            <li
              class="certified_tooltip pointer mb-1 bg-certified"
              v-if="car.certified !== 'N' && car.stock_type === 'used'"
              :data-certified="car.certified"
              data-toggle="modal"
              data-target="#certified_modal">
              <span class="text-white px-2 py-1 mb-2 small text-capitalize certified  d-block">
                <svg class="icon icon-star3"><use xlink:href="/assets/svg/symbol-defs.svg#icon-star3"></use></svg> {{ car.certified }} Certified Pre-Owned
              </span>
            </li>

            <li
              class="pointer mb-1 mt-2 bg-fresh"
              v-if="car.fresh === 1 && car.status_group === 'In-Stock'"
              data-target="#fresh_modal"
              data-toggle="modal"
            >
              <span class="text-white px-2 py-1 mb-2 small fresh d-block">
                <svg class="icon icon-star3"><use xlink:href="/assets/svg/symbol-defs.svg#icon-star3"></use></svg> Fresh on the Lot
              </span>
            </li>

            <li
              class="pointer mb-1"
              v-if="car.status === 'In-Transit'"
              :data-status="car.status_group"
              data-toggle="modal"
              data-target="#in_stock_soon_modal">
              <span class="bg-in-transit px-2 py-1 mb-2 small in-transit d-block">
                <svg class="icon icon-star3"><use xlink:href="/assets/svg/symbol-defs.svg#icon-star3"></use></svg> In-Transit
              </span>
            </li>

          </ul>

          <a :href="'/assets/autocheck/' + car.vin + '.html'" target="_blank" rel="noopener noreferrer" v-if="car.autocheck === 'yes'"><img src="/images/site/vehicles/autocheck_logo.png" class="py-3" width="170px" /></a>

        </div>

        </div>

        <div class="col-12">

          <p v-if="(typeof car.incentives) !== 'undefined'" class="smallish my-1">

            <span v-for="(incentive, incentiveIndex) in car.incentives" :key="incentive.incentive_id">

            <span v-if="incentiveIndex === 0"><strong>Manufacturer Offers: </strong></span>

              <a
                href="#"
                :data-incentive-id="incentive.incentive_id"
                data-toggle="modal"
                data-target="#incentivesModal">
                <span v-if="incentive.incentive_type === 'Cash'">${{ addComma(incentive.incentive_value) }} {{ incentive.incentive_description }}</span>
                <span v-if="incentive.incentive_type === 'Finance'">{{ incentive.incentive_description }} ({{ incentive.incentive_value }})</span>
              </a>
                <span v-if="incentiveIndex + 1 < car.incentives.length">, </span>

            </span>

          </p>

        </div>

        <div class="col-md-6" v-if="car.status !== 'Reserved'">

          <a
            class="btn btn-primary btn-block py-2 my-2"
            style="padding-top: .85rem; padding-bottom: .85rem;"
            :href="getViewDetailsLink(car)"
            :title="'View More Details on this ' + car.year + ' ' + car.make + ' ' + car.model"
          >VIEW DETAILS
          </a>

        </div>

        <div class="col-md-6" v-if="car.status !== 'Reserved'">

          <div style="width:100%;" class="btn btn-cta btn-block cn-button-container my-2" :data-vin="car.vin" data-page-type="srp" :data-type="car.stock_type">PRICING &amp; PAYMENTS</div>

        </div>

        <div class="col-12" v-if="car.status === 'Reserved'">

          <div class="row border border-reserved mx-0 py-3 my-2">

            <div class="col-12 d-flex">
              <div class="align-self-center">
                <h5 class="text-reserved"><i class="fa-solid fa-circle-info"></i> RESERVED VEHICLE</h5>
                <p class="mb-0">This vehicle is currently reserved but we have more.
                  <a
                    href="#"
                    :data-vehicle-year="car.year"
                    :data-vehicle-make="car.make"
                    :data-vehicle-model="car.model"
                    :data-stock-num="car.stock_num"
                    :data-vehicle-id="car.transit_id"
                    data-toggle="modal"
                    data-target="#moreInfoModal">
                    <span class="d-none d-md-inline"> Reserve yours today!</span>
                  </a>
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

    <div v-if="viewFormat === 'list'" class="listView">

      <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Vehicle</th>
            <th scope="col" class="d-none d-md-table-cell">Trim</th>
            <th scope="col" class="d-none d-md-table-cell">Color</th>
            <th scope="col">MSRP</th>
            <th scope="col">List</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr :class="isReserved(car.status)" v-for="car in carsFiltered" :key="car.vin + car.order_num" :data-vin="car.vin">
            <th scope="row"><i class="fa-solid fa-circle mr-2" :class="statusTextColor(car)"></i>{{ car.year }} {{ car.make }} {{ car.model }}</th>
            <td class="d-none d-md-table-cell small">{{ car.trim }}</td>
            <td class="d-none d-md-table-cell small">{{ car.color }}</td>
            <td><span v-if="car.sticker_price > 0">${{ addComma(car.sticker_price) }}</span><span v-else>N/A</span></td>
            <td><span v-if="car.final_price > 0">${{ addComma(car.final_price) }}</span><span v-else>N/A</span></td>
            <td align="right">
              <a
                href="#"
                class="link gtm__complete_inventory_more_info"
                style="padding: .5rem;"
                :data-vehicle-year="car.year"
                :data-vehicle-make="car.make"
                :data-vehicle-model="car.model"
                :data-stock-num="car.stock_num"
                :data-vehicle-id="car.transit_id"
                data-toggle="modal"
                data-target="#moreInfoModal">
                <span class="d-none d-md-inline">More </span>Info
              </a>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    </div>

  </div>

</template>

<script>

import { mapState } from 'vuex'

// import bootstrap-vue components
import { VBToggle, BCollapse } from 'bootstrap-vue'

export default {
  name: 'SearchResults',
  components: {
    BCollapse
  },
  directives: {
    'b-toggle': VBToggle
  },
  data () {
    return {
      priceVisible: true,
      user: {}
    }
  },
  computed: {
    ...mapState(['cars', 'carsFiltered', 'viewFormat']),
    showHiddenPricing () {
      if (typeof (this.user) !== 'undefined') {
        if (this.user.group_id === '1' || this.user.group_id === '12') {
          return true
        }
        return false
      }
      return false
    }
  },
  created () {
    // this.togglePriceVisibility()
    if (typeof (window.Cag.user) !== 'undefined') {
      this.user = window.Cag.user
    }
  },
  mounted () {
  },
  methods: {
    addComma: function (value) {
      return parseInt(value).toLocaleString()
    },
    allIncentives: function (incentives) {
      var allIncentives = []
      for (const incentiveGroup in incentives) {
        // console.log(incentiveGroup)
        // console.log(incentives[incentiveGroup])
        for (const incentive in incentives[incentiveGroup]) {
          // console.log('incentive', incentive)
          var incentiveId = incentives[incentiveGroup][incentive].incentive_id
          allIncentives[incentiveId] = incentives[incentiveGroup][incentive]
        }
      }
      return allIncentives
    },
    prettyEndDate (endDate) {
      const unixTimestamp = Date.parse(endDate)
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      var date = new Date(unixTimestamp)
      // Years part from the timestamp
      var year = date.getFullYear()
      // Month part from the timestamp
      // var month = date.getMonth()

      var day = date.getDate()

      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

      const monthName = monthNames[date.getMonth()]

      // Will display time in 10:30:23 format
      var formattedTime = monthName + ' ' + day + ', ' + year

      return formattedTime
    },
    // togglePriceVisibility () {
    //   var collapsePriceBreakpoint = 577
    //   var windowWidth = window.outerWidth

    //   console.log('togglePriceVisibility', windowWidth)

    //   // larger than mobile
    //   if (windowWidth <= collapsePriceBreakpoint) {
    //     console.log('collapse')
    //     this.priceVisible = false
    //   } else {
    //     console.log('open')
    //     this.priceVisible = true
    //   }
    // },
    isAlaskaPackage (optionCode) {
      if (optionCode) {
        if ((optionCode === 'AKP' || optionCode === 'AK')) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    status (car) {
      if (typeof (car) === 'undefined') {
        return ''
      }
      switch (true) {
        case (car.certified !== 'N'):
          return 'Certified'
        case (car.book_value > 1 || car.on_special === 'y'):
          return 'Special'
        case (car.status === 'In-Transit'):
          return 'In-Transit'
        case (car.fresh === 1 && car.status !== 'Reserved'):
          return 'Fresh'
        case (car.status === 'Reserved'):
          return 'Reserved'
        case (car.status === 'In-Stock'):
          return 'In-Stock'
      }
    },
    statusTextColor (car) {
      if (typeof (car) === 'undefined') {
        return ''
      }
      const classes = []

      switch (true) {
        case (car.certified !== 'N'):
          classes.push('text-certified')
          break
        case (car.on_special === 'y'):
          classes.push('text-special')
          break
        case (car.status === 'In-Transit'):
          classes.push('text-in-transit')
          break
        case (car.fresh === 1 && car.status !== 'Reserved'):
          classes.push('text-fresh')
          break
        case (car.status === 'Reserved'):
          classes.push('text-reserved')
          break
        default:
          classes.push('text-in-stock')
          break
      }

      const returnData = ' ' + classes.join(' ')

      return returnData
    },
    statusBGColor (car) {
      if (typeof (car) === 'undefined') {
        return ''
      }
      const classes = []

      switch (true) {
        case (car.certified !== 'N'):
          classes.push('bg-certified')
          break
        case (car.on_special === 'y'):
          classes.push('bg-special')
          break
        case (car.status === 'In-Transit'):
          classes.push('bg-in-transit')
          break
        case (car.fresh === 1 && car.status !== 'Reserved'):
          classes.push('bg-fresh')
          break
        case (car.status === 'Reserved'):
          classes.push('bg-reserved')
          break
        default:
          classes.push('bg-in-stock')
          break
      }

      const returnData = ' ' + classes.join(' ')

      return returnData
    },
    isReserved (status) {
      if (status === 'Reserved') {
        return 'text-danger'
      }
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    getViewDetailsLink (car) {
      let link = ''
      if (car.stock_num) {
        link = '/vehicles/vehicle_details/continental/?stock_num=' + car.stock_num
      } else {
        link = '/vehicles/vehicle_details/continental/?transit_id=' + car.transit_id
      }
      return link
    }
  }
}
</script>

<style lang="scss">

  .pricing-table-border {
    border-bottom: 1px solid #8e8e8e;
  }

  .listView span.cn-btn-bn1--label {
    font-size: 14px!important;
  }
  span.cn-btn-bn1--label {
    padding-bottom: 0;
    margin-bottom: 0;
    vertical-align: baseline;
  }

  .tooltip {
    pointer-events: none;
  }

  @media only screen and (min-width: 1280px) {
    /* Year Make & Model */
    .ymm {
      font-size: 1.2rem;
    }
  }

  /* commented out due to conflicts with desktop main nav
  .show {
    display: inherit !important;
  }
  */
</style>
